import React, { useEffect, useState, memo } from "react"

import { sanitizeAndDecodeHtml, validateField } from "@/utils/helper"
import {
  addDatalayerLocalStoreHrefClick,
  getAnalyticsData,
  getProductInfoAnalytics,
  pushAnalyticsToDataLayer,
} from "@/components/ProductDetail/v3/AddToCart/analytics"

import Button from "@/components/core/Button/Button"
import Input from "@/components/core/Input/Input"

import { callNotification } from "@/components/ProductDetail/v3/AddToCart/utils"
import { quickViewNotifyMeClickAnalytics } from "@/components/Shared/QuickView/analytics"

const OutOfStockSection = props => {
  const {
    outOfStockMsg,
    localStoreOrShowroomRef,
    findStoreUrl = "",
    sku = "",
    staticTexts = {},
    productData,
    productInfoQV,
    id = "",
    upshellmodal,
    recommendationSource,
    isMultifinishBundle = false,
    productOptionCategory = "",
    plp = false,
    search = false,
  } = props
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState({ show: false, message: "" })
  const [showWelcome, setShowWelcome] = useState(false)
  const [enableNotify, setEnableNotify] = useState(false)

  const {
    outOfStock = "",
    notifyEmailTxt = "",
    findLocalStore = "",
    toCheckAvailability = "",
    emailAddress = "",
    notifyMailCTA = "",
    successTxt = "",
    successMsg = "",
    outOfStockError = "",
    productAnalyticsData = {},
  } = staticTexts

  const productInfo = productData
    ? JSON.parse(productData.stringProductInfo).productInfo
    : productAnalyticsData

  const handleEmailChange = async val => {
    const inputValue = val.trim()
    setEmailError({ show: false, message: "" })
    setEmail(inputValue)
    if (!(await validateField("email", inputValue))) {
      setEnableNotify(false)
    } else {
      setEnableNotify(true)
    }
  }

  const callBackNotify = isSuccess => {
    if (isSuccess) {
      setShowWelcome(true)
      setEmail("")
      setEnableNotify(false)
      if (id === "quick-view") {
        quickViewNotifyMeClickAnalytics({
          productInfo: productInfoQV,
          upshellmodal,
          recommendationSource,
          isSuccess,
          isMultifinishBundle,
          productOptionCategory,
          plp,
          search,
        })
      }
    } else {
      setEmailError({
        show: true,
        message: outOfStockError,
      })
      if (id === "quick-view") {
        quickViewNotifyMeClickAnalytics({
          productInfo: productInfoQV,
          upshellmodal,
          recommendationSource,
          isSuccess,
          errorMsgQV: outOfStockError,
          isMultifinishBundle,
          productOptionCategory,
          plp,
          search,
        })
      }
    }
  }

  const handleNotification = () => {
    callNotification({ email, sku, callBackNotify })
    const eventInfo = JSON.parse(getAnalyticsData(notifyMailCTA))
    const productInfoData = getProductInfoAnalytics(productData)
    pushAnalyticsToDataLayer(eventInfo, productInfoData)
  }

  useEffect(() => {
    const localStoreOrShowroomHrefElement = document.querySelectorAll(
      ".out-of-stock-description a"
    )

    if (localStoreOrShowroomHrefElement) {
      $(document).on("click", ".out-of-stock-description a", function (e) {
        let type = e.target.textContent.trim() // Trim to remove extra spaces
        const link = e.target.getAttribute("href")
        // Check if it's an email
        if (type.includes("@")) {
          addDatalayerLocalStoreHrefClick(type, link, productInfo)
          return
        }

        // ("String contains a number from 1 to 9")
        if (/[1-9]/.test(type)) {
          type = "sales support:" + type
          addDatalayerLocalStoreHrefClick(type, link, productInfo)
          return
        }

        // Fallback: any string
        if (typeof type === "string" && type.includes("store")) {
          const internalLink =
            link.indexOf("http") === -1 ? window.location.origin + link : link
          addDatalayerLocalStoreHrefClick(type, internalLink, productInfo)
        }
      })
    }

    // Cleanup to remove the event listener when component unmounts
    return () => {
      $(document).off("click", ".out-of-stock-description a")
    }
  }, []) // empty array as dependency

  return (
    <div className="out-of-stock-container">
      {!showWelcome ? (
        <>
          <span className="out-of-stock">{outOfStock}</span>
          {outOfStockMsg ? (
            <span
              className="out-of-stock-description"
              ref={localStoreOrShowroomRef}
            >
              {sanitizeAndDecodeHtml(outOfStockMsg)}
            </span>
          ) : (
            <span className="out-of-stock-description">
              {`${notifyEmailTxt} `}
              <a href={findStoreUrl}>{findLocalStore}</a>
              {` ${toCheckAvailability}`}
            </span>
          )}
          <div className="notify-email">
            <div className="notify-email__input">
              <Input
                id={id || "email"}
                ariaRequried={true}
                type="text"
                maxLength={60}
                value={email}
                label={emailAddress}
                onChange={e => handleEmailChange(e.target.value)}
                showError={emailError.show}
                errorMessage={emailError.message}
              />
            </div>
            <div className="notify-btn">
              <Button
                role="button"
                className="gbh-data-layer"
                data-gbh-data-layer-custom={
                  productAnalyticsData.stringProductInfo
                }
                label={notifyMailCTA}
                onClick={handleNotification}
                size="large"
                type="primary"
                flexible={true}
                disabled={!enableNotify}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="out-of-stock__success-message">
          <p className="out-of-stock__thank-title">{successTxt}</p>
          <p className="out-of-stock__thank-description">
            {sanitizeAndDecodeHtml(successMsg)}
          </p>
        </div>
      )}
    </div>
  )
}

export default memo(OutOfStockSection)
